import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css', './app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'Dashboard';
}
